/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TestStepDto } from './TestStepDto';
export type BaseTestGroupDto = {
    readonly id?: string;
    readonly createdDate?: string;
    readonly createdBy?: string;
    readonly modifiedDate?: string;
    readonly modifiedBy?: string;
    readonly version?: number;
    name?: string;
    subTitle?: string;
    testAreaId?: string;
    testGroupType: BaseTestGroupDto.testGroupType;
    readonly testSteps?: Array<TestStepDto>;
};
export namespace BaseTestGroupDto {
    export enum testGroupType {
        SPECIFICATION = 'SPECIFICATION',
        GENERIC = 'GENERIC',
    }
}

